import { IS_DEBUG, SECURITY_CROSS, GET_LOGOUT } from "./urlConfig";
import swal from 'sweetalert';
import moment from 'moment'
import { REQUEST_SERVICE } from "./requestConfig";
import { target } from "vuelidate/lib/params";

let utilService = {};

let _setTheme = function () {
  try {
    let chooseTheme = JSON.parse(window.localStorage.getItem('darkMode'));
    if (chooseTheme) {
      if (chooseTheme.dark) {
        document.documentElement.style.setProperty('--bodyColor', '#20222C');
        document.documentElement.style.setProperty('--bodyColor2', '#20222C');
        document.documentElement.style.setProperty('--bodyContrast', '#313A46');
        document.documentElement.style.setProperty('--leftMenuColor', '#2A2C38');
        document.documentElement.style.setProperty('--text', '#7E8DA7');
        document.documentElement.style.setProperty('--registerPointColor', '#3A424E')
        document.documentElement.style.setProperty('--registerPointColorBackgroundHover', '#3A424E')
        document.documentElement.style.setProperty('--registerPauseDarkSelected', '#fff')
        document.documentElement.style.setProperty('--pausedText', '#3A424E');
        document.documentElement.style.setProperty('--pausedBackground', '#ffffff')
        document.documentElement.style.setProperty('--darkBlue', '#A8C0FF');
        document.documentElement.style.setProperty('--lightBlue', '#1b59f8')
        document.documentElement.style.setProperty('--textTag', '#3A424E');
        document.documentElement.style.setProperty('--gradientWhite', '#fff');
        document.documentElement.style.setProperty('--borderGray', '#A8C0FF');
        document.documentElement.style.setProperty('--opacityBackground', 'rgba(255, 255, 255, 0.35)');
        document.documentElement.style.setProperty('--pausedBox', '#2A2C38');
        document.documentElement.style.setProperty('--darkText', '#2A2C38');
        document.documentElement.style.setProperty('--pausedProgressBar', '#fff');
        document.documentElement.style.setProperty('--pausedGradientBarStart', '#3A424E');
        document.documentElement.style.setProperty('--pausedGradientBarEnd', '#f9f9f9 ');

        document.documentElement.style.setProperty('--line', '#1F272E');
        document.documentElement.style.setProperty('--blueText', '#fff')
        document.documentElement.style.setProperty('--border', '#20222C')
        document.documentElement.style.setProperty('--registerPause', '#fff')

        document.documentElement.style.setProperty('--activeHoverSidebar', '#FFF');
        document.documentElement.style.setProperty('--activeHoverSidebar2', '#1F272E');
        document.documentElement.style.setProperty('--titleSide', '#D5DFEB');
        document.documentElement.style.setProperty('--textSide', '#97AEC9');
        document.documentElement.style.setProperty('--textActiveSide', '#7E87FF');
        document.documentElement.style.setProperty('--btnBkSide', '#7E87FF');
        document.documentElement.style.setProperty('--btnTextSide', '#FFFFFF');
        document.documentElement.style.setProperty('--iconSide', '#97AEC9');
        document.documentElement.style.setProperty('--iconActiveSide', '#7E87FF');

        document.documentElement.style.setProperty('--titleBox', '#D5DFEB');
        document.documentElement.style.setProperty('--defaultText', '#97AEC9');
        document.documentElement.style.setProperty('--linkColor', '#7E87FF');
        document.documentElement.style.setProperty('--redColor', '#F26678');
        document.documentElement.style.setProperty('--yellowColor', '#FFCC80');
        document.documentElement.style.setProperty('--yellowColor2', '#FFCC80');
        document.documentElement.style.setProperty('--greenColor', '#67D492');
        document.documentElement.style.setProperty('--blueDark', '#7E87FF');
        document.documentElement.style.setProperty('--backgroundProgress', '#1F272E');
        document.documentElement.style.setProperty('--cardBackground', '#1F272E');
        document.documentElement.style.setProperty('--footerColor', '#191919');
        document.documentElement.style.setProperty('--loadingThemeStart', '#4e5458');
        document.documentElement.style.setProperty('--loadingThemeInterval', '#6e7479');
        document.documentElement.style.setProperty('--yellowWithText', '#F1A868');
        document.documentElement.style.setProperty('--backgroundPoint', '#1F272E');
      } else {
        document.documentElement.style.setProperty('--bodyColor', '#F9F9F9');
        document.documentElement.style.setProperty('--bodyColor2', '#F9F9F9');
        document.documentElement.style.setProperty('--leftMenuColor', '#FFFFFF')
        document.documentElement.style.setProperty('--registerPointColor', '#FFFFFF')
        document.documentElement.style.setProperty('--text', '#3A424E');
        document.documentElement.style.setProperty('--darkBlue', '#1b59f8');
        document.documentElement.style.setProperty('--lightBlue', '#A8C0FF');
        document.documentElement.style.setProperty('--textTag', '#fff');
        document.documentElement.style.setProperty('--gradientWhite', '#cedcff');
        document.documentElement.style.setProperty('--borderGray', '#ebebeb');
        document.documentElement.style.setProperty('--opacityBackground', 'rgba(0, 0, 0, 0.35)')
        document.documentElement.style.setProperty('--pausedBox', '#1B59F8')
        document.documentElement.style.setProperty('--darkText', '#1b59f8');
        document.documentElement.style.setProperty('--pausedProgressBar', '#4478FF');
        document.documentElement.style.setProperty('--pausedGradientBarStart', '#fff');
        document.documentElement.style.setProperty('--pausedGradientBarEnd', '#84A6FF ');

        document.documentElement.style.setProperty('--registerPause', '#A1A2A5')
        document.documentElement.style.setProperty('--registerPointColorBackgroundHover', '#1B59F8')
        document.documentElement.style.setProperty('--registerPauseDarkSelected', '#1b59f8')
        document.documentElement.style.setProperty('--bodyContrast', '#FFFFFF');
        document.documentElement.style.setProperty('--line', '#F2F5F9');
        document.documentElement.style.setProperty('--border', '#EBEBEB')
        document.documentElement.style.setProperty('--pausedText', '#fff');
        document.documentElement.style.setProperty('--pausedBackground', '#1b59f8')
        document.documentElement.style.setProperty('--imageBorder', '#ffffff')

        document.documentElement.style.setProperty('--blueText', '#1b59f8');
        document.documentElement.style.setProperty('--activeHoverSidebar', '#3A424E');
        document.documentElement.style.setProperty('--activeHoverSidebar2', '#F2F5F9');
        document.documentElement.style.setProperty('--titleSide', '#7F8897');
        document.documentElement.style.setProperty('--textSide', '#3A424E');
        document.documentElement.style.setProperty('--textActiveSide', '#352DA5');
        document.documentElement.style.setProperty('--btnBkSide', '#D5DFEB');
        document.documentElement.style.setProperty('--btnTextSide', '#3A424E');
        document.documentElement.style.setProperty('--iconSide', '#3A424E');
        document.documentElement.style.setProperty('--iconActiveSide', '#352DA5');

        document.documentElement.style.setProperty('--titleBox', '#191919');
        document.documentElement.style.setProperty('--defaultText', '#7F8897');
        document.documentElement.style.setProperty('--linkColor', '#352DA5');
        document.documentElement.style.setProperty('--redColor', '#FF445D');
        document.documentElement.style.setProperty('--yellowColor', '#FFAB2D');
        document.documentElement.style.setProperty('--yellowColor2', '#FDD944');
        document.documentElement.style.setProperty('--greenColor', '#08A747');
        document.documentElement.style.setProperty('--blueDark', '#1A0F6B');
        document.documentElement.style.setProperty('--backgroundProgress', '#D5DFEB');
        document.documentElement.style.setProperty('--cardBackground', '#FFFFFF');
        document.documentElement.style.setProperty('--footerColor', '#352DA5');
        document.documentElement.style.setProperty('--loadingThemeStart', '#ededed');
        document.documentElement.style.setProperty('--loadingThemeInterval', '#e0dede');
        document.documentElement.style.setProperty('--yellowWithText', '#FFAB2D');
        document.documentElement.style.setProperty('--backgroundPoint', '#9ba1a8');
      }
    }
  } catch (e) { }
};

let _historyLog = function (onlyCreate, route, actionName, objectAction, status, reason) {
  const logHistory = _getStorage('logHistory');

  if (!logHistory) {
    _saveStorage('logHistory', { listPages: [] });
  } else {
    if (!onlyCreate) {
      const checkDate = new Date(moment().subtract(1, 'week').endOf('day')).getTime();
      const objectAdd = {
        date: new Date(),
        dateTime: new Date().getTime(),
        route: route,
        onAction: actionName,
        dataAction: objectAction,
        isError: status,
        reason: reason
      };
      console.log(objectAdd, 'OBJECT ADD');

      logHistory.listPages.map((value, index) => {
        if (value.dateTime < checkDate) {
          logHistory.listPages.splice(index, 1);
        }
      });

      setTimeout(() => {
        logHistory.listPages.unshift(objectAdd);

        console.log(logHistory.listPages, 'UNSHIFT ADDED');
        _saveStorage('logHistory', logHistory);
      }, 1000);
    }
  }
};

let _console = function (string, value) {
  if (IS_DEBUG) {
    console.log("------------------------ Console --------------------------");
    console.log(string, value);
    console.log("-----------------------------------------------------------");
  }
};

let _showErrorsInDev = function (url, err, status, dataValue) {
  if (IS_DEBUG) {
    console.log("---------------------- Error ----------------------------");
    console.log("URL: ", url);
    console.log("Value JSON: ", dataValue);
    console.log("Erro: ", err);
    console.log("Status: ", status);
    console.log("---------------------------------------------------------");
  }
};

let _invalidToken = function (status, error) {
  if (typeof error === "undefined") {
    if (status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
  } else if (error.length) {
    if (error[0].value) {
      swal({
        title: "Aviso",
        text: error[0].value,
        icon: "error",
        button: {
          text: "Confirmar",
          closeModal: true,
        }
      }).then(continueResult => {
        localStorage.clear();
        window.location.href = '/login';
      });
    } else {
      if (status === 401) {
        localStorage.clear();
        window.location.href = '/login';
      }
    }
  } else {
    if (status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
  }
};

let _checkBrowser = function () {
  if (/MSIE 10/i.test(navigator.userAgent)) {
    window.alert('isIE10');
    return {
      name: "Internet Explorer 10",
      version: ""
    };
  } else if (/MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent)) {
    return {
      name: "Internet Explorer 9 or 11",
      version: ""
    };
  } if (document.documentMode || /Edge/.test(navigator.userAgent)) {
    return {
      name: "Microsoft Edge",
      version: ""
    };
  } else {
    let ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return { name: 'IE', version: (tem[1] || '') };
    }

    if (M[1] === 'Chrome') {
      tem = ua.match(/\bOPR\/(\d+)/)
      if (tem != null) { return { name: 'Opera', version: tem[1] }; }
    }

    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];

    if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
    return {
      name: M[0],
      version: M[1]
    };
  }
};

let _randomToken = function () {
  let randomPool = new Uint8Array(32);
  crypto.getRandomValues(randomPool);
  let hex = '';
  for (let i = 0; i < randomPool.length; ++i) {
    hex += randomPool[i].toString(16);
  }
  return hex
};

let _checkDateStringIsInvalid = function (value) {
  value = value.split("/").reverse().join("-");
  let checkDate = new Date(value);
  return !checkDate.getTime();
};

let _convertStringToDateEua = function (value) {
  value = value.split("/").reverse().join("-");
  return value;
};

let _getStorage = function (name) {
  return JSON.parse(window.localStorage.getItem(name));
};

let _saveStorage = function (name, value) {
  _console('SAVE STORAGE VALUE: ' + name, value);

  window.localStorage.setItem(name, JSON.stringify(value));
};

let _checkLocationAndRedirectToV2 = function (language, page) {
  const auth = JSON.parse(localStorage.getItem('authUser'));
  const companyId = JSON.parse(localStorage.getItem('userInfo')).companyId;
  const userId = JSON.parse(localStorage.getItem('userInfo')).id;
  const contentSetting = JSON.parse(localStorage.getItem('authUser')).userContentSetting;

  if (!language) {
    language = (navigator.browserLanguage !== undefined) ? navigator.browserLanguage : navigator.language;
  }
  if (location.hostname.includes("localhost")) {
    window.location.href = `http://localhost:5173/${page}?tid=${auth.token}&fw=1&cid=${companyId}&uid=${userId}&cset=${contentSetting}`
  }
  else if (location.hostname.includes("127.0.0.1") || location.hostname.includes("dev") || location.hostname.includes("backoffice2")) {
    window.location.href = `https://marqhr-backoffice-dev.azurewebsites.net/${page}?tid=${auth.token}&fw=1&cid=${companyId}&uid=${userId}&cset=${contentSetting}`;
  } else {
    window.location.href = `https://app.marqhr.com/${page}?tid=${auth.token}&fw=1&cid=${companyId}&uid=${userId}&cset=${contentSetting}`;
  }
}

let _redirectManagerToUserProfile = function(page, id) {
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  const myTeam = JSON.parse(localStorage.getItem('myTeam'));
  const auth = JSON.parse(localStorage.getItem('authUser'));
  const companyId = JSON.parse(localStorage.getItem('userInfo')).companyId;


  if(!myTeam) {
    return null;
  }

  if(userInfo.role === 1 && myTeam.isManager) {
    if (location.hostname.includes("localhost") || location.hostname.includes("127.0.0.1") || location.hostname.includes("dev") || location.hostname.includes("backoffice2")) {
      window.open(`https://marqhr-backoffice-dev.azurewebsites.net/${page}/${id}?tid=${auth.token}&fw=1&cid=${companyId}&uid=${userInfo.id}&cset=${auth.contentSetting}`, '_blank');
    } else {
      window.open( `https://app.marqhr.com/${page}/${id}?tid=${auth.token}&fw=1&cid=${companyId}&uid=${userInfo.id}&cset=${auth.contentSetting}`, '_blank');
    }
  } else {
    if (location.hostname.includes("localhost") || location.hostname.includes("127.0.0.1") || location.hostname.includes("dev") || location.hostname.includes("backoffice2")) {
      window.open(`https://marqponto-backoffice-dev.azurewebsites.net/lista-de-funcionarios`, '_blank');
    } else {
      window.open(`https://app.marqponto.com.br/lista-de-funcionarios`, '_blank')
    }
  }
}

let _checkTokenV2ToAccessPage = function () {
  const dataUrl = new URLSearchParams(window.location.search);
  const auth = JSON.parse(localStorage.getItem('authUser'));
  const token = auth.token;
  const tokenv2 = dataUrl.get('tid');

  if (tokenv2 !== token) {
    REQUEST_SERVICE.get(GET_LOGOUT + `?c=${token}`).then(response => {
      _console('RESULT', response);
    })
    REQUEST_SERVICE.logout().then(response => {
      _console('RESULT', response);
    });
  }
}

let _limitTo = function (text, limit) {
  if (!text) return '';
  if (text.length <= limit) return text;
  return text.substring(0, limit) + '...';
};

utilService.setTheme = _setTheme;
utilService.saveStorage = _saveStorage;
utilService.getStorage = _getStorage;
utilService.randomToken = _randomToken;
utilService.console = _console;
utilService.showErrorsInDev = _showErrorsInDev;
utilService.invalidToken = _invalidToken;
utilService.checkBrowser = _checkBrowser;
utilService.checkDateStringIsInvalid = _checkDateStringIsInvalid;
utilService.convertStringToDateEua = _convertStringToDateEua;
utilService.historyLog = _historyLog;
utilService.checkLocationAndRedirectToV2 = _checkLocationAndRedirectToV2;
utilService.checkTokenV2ToAccessPage = _checkTokenV2ToAccessPage;
utilService.redirectManagerToUserProfile = _redirectManagerToUserProfile;
utilService.limitTo = _limitTo;

export const UTIL_SERVICE = utilService;



// WEBPACK FOOTER //
// ./src/utils.js